import React from "react";
import Page from "Pages/_Layouts/DefaultInternal";
import { useTranslation } from "react-i18next";
import Loading from "customHooks/useCompleoForm/helpers/Loading";
import { navigate } from "@gatsbyjs/reach-router";
import {
    AuthProvider,
    useAuthorization,
    useAuthState
} from "_ReactContext/AuthContext";
import useGetMetadata from "customHooks/useGetMetadata";
import {
    useCompleoSimpleList,
    actionsTableFunction
} from "customHooks/useCompleoSimpleList";
import Icon from "@material-ui/core/Icon";
import useActionsTable from "./components/useActionsTable";

const UserList = (props: any) => {
    const [t, i18n, readyTranslation] = useTranslation("USERLIST", {
        useSuspense: false
    });
    const [metadata] = useGetMetadata("USERLIST");
    const listAddress = "/user/list";
    const { company } = useAuthState();
    const { isFeatureAuthorized } = useAuthorization();
    const actions: actionsTableFunction = useActionsTable(company.companyId, t);

    const [renderTable, finished] = useCompleoSimpleList(
        t,
        metadata,
        listAddress,
        "post",
        {
            companyId: company.companyId
            // totalFakeDataMultiply: 650
        },
        isFeatureAuthorized("EditUser") ? actions : []
    );

    let compRetorno: null | JSX.Element = <Loading />;
    if (readyTranslation && finished) {
        compRetorno = renderTable();
        return (
            <Page
                featureName={t("a_FeatureName")}
                featureMainDescription={t("a_FeatureMainDescription")}
                maxWidth="lg"
                rightButton={
                    isFeatureAuthorized("AddUser")
                        ? {
                              text: t("buttonTopRight"),
                              action: () => navigate(`/user/new`),
                              enabled: true,
                              startIcon: <Icon>add</Icon>
                          }
                        : undefined
                }
            >
                {compRetorno}
            </Page>
        );
    } else {
        return <Page>{compRetorno}</Page>;
    }
};

export default UserList;
